import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EncryptionService } from './encryption.service';
// Import RxJs required methods
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Router } from '@angular/router';
import { APIEndpoint } from '../appsettings/BaseUrl';

@Injectable()
export class SubjectService {
  
  private BASE_URL: string;
  _headers:any;
  constructor(private http:HttpClient, private _router:Router,private EncryptionService:EncryptionService) {
    this.BASE_URL = APIEndpoint.BaseUrl;
    this._headers= new HttpHeaders({
    'Client-Service': 'LRL2018SH',
    'Auth-Key': '5ccd7b534b19d30030c6503f3a852d00',
    'Content-Type': 'application/json'
  })
  }
  AddSubject(data):Observable<any>{    
    const url = this.BASE_URL + 'add-subject';
    return this.http.post(url,data,{headers:this._headers}).map(res=>res);
  }

  UpdateSubject(data):Observable<any>
  {
    const url = this.BASE_URL + 'update-subject';
    return this.http.post(url,data,{headers:this._headers}).map(res=>res).catch((e:any)=>{
      return Observable.throw(e);
    });
  }
  DeleteSubject(data):Observable<any>
  {
    const url = this.BASE_URL + 'delete-subject';
    return this.http.post(url,data,{headers:this._headers}).map(res=>res).catch((e:any)=>{
      return Observable.throw(e);
    });
  }

  GetSubjectList():Observable<any>
  {    
    const url = this.BASE_URL + 'subject-list';
    return this.http.post(url,{},{headers:this._headers}).map(res=>res);
  }  
  SearchSubject(data):Observable<any>
  {    
    const url = this.BASE_URL + 'search-subject';
    return this.http.post(url,data,{headers:this._headers}).map(res=>res);
  }
  ElectiveSubjectAdd(data):Observable<any>
  {    
    const url = this.BASE_URL + 'add-elective-subject';
    return this.http.post(url,data,{headers:this._headers}).map(res=>res).catch((e:any)=>{
      return Observable.throw(e);
    });
  }
  ElectiveSubjectDel(data):Observable<any>
  {    
    const url = this.BASE_URL + 'delete-elective-subject';
    return this.http.post(url,data,{headers:this._headers}).map(res=>res).catch((e:any)=>{
      return Observable.throw(e);
    });
  }
  SubjectByClass(data):Observable<any>
  {    
   let user_id=localStorage.getItem('user_id');
   user_id=this.EncryptionService.DecryptText(user_id);
   let role_id=localStorage.getItem('role_id');
   role_id=this.EncryptionService.DecryptText(role_id);    
   if(role_id=="3")
   {
    data={teacher_id:user_id,class_id:data.class_id,section_id:data.section_id};
   }

    const url = this.BASE_URL + 'subject-list-by-class';
    return this.http.post(url,data,{headers:this._headers}).map(res=>res).catch((e:any)=>{
      return Observable.throw(e);
    });
  }

  SubjectByTeacher(data):Observable<any>
  {    
   let user_id=localStorage.getItem('user_id');
   user_id=this.EncryptionService.DecryptText(user_id);
   let role_id=localStorage.getItem('role_id');
   role_id=this.EncryptionService.DecryptText(role_id);    
   if(role_id=="3")
   {
    data={teacher_id:user_id,class_id:data.class_id,section_id:data.section_id};
   }

    const url = this.BASE_URL + 'subject-list-by-teacher';
    return this.http.post(url,data,{headers:this._headers}).map(res=>res).catch((e:any)=>{
      return Observable.throw(e);
    });
  }
  

}
